<script lang="ts" setup>
import { LoginType, useLoginStore } from '@/login/stores/useLoginStore';
import { storeToRefs } from 'pinia';

const loginStore = useLoginStore();
const { loginType } = storeToRefs(loginStore);
</script>
<template>
    <SStack gap="5" class="my-7">
        <SContentDivider class="flex-grow-1" />
        <SText>{{ $t('components.login.orLoginWith') }}</SText>
        <SContentDivider class="flex-grow-1" />
    </SStack>

    <SStack
        vertical
        gap="4"
        class="mb-7"
    >
        <SButton
            v-if="loginType !== LoginType.BankId"
            variant="secondary-light"
            variant-type="outline"
            :disabled="loginStore.loggingIn"
            class="p-0"
            block
            size="lg"
            @click="loginStore.setLoginType(LoginType.BankId)"
        >
            <SStack>
                <img
                    src="@/assets/img/bankid.png"
                    alt="BankID"
                    style="height: 44px;"
                />
                <span>{{ $t('components.login.bankId') }}</span>
            </SStack>
        </SButton>
        <SButton
            v-if="loginType !== LoginType.SSO"
            variant="secondary-light"
            variant-type="outline"
            :disabled="loginStore.loggingIn"
            block
            size="lg"
            @click="loginStore.setLoginType(LoginType.SSO)"
        >
            {{ $t('components.login.sso') }}
        </SButton>
        <SButton
            v-if="loginType !== LoginType.Password"
            variant="secondary-light"
            variant-type="outline"
            :disabled="loginStore.loggingIn"
            block
            size="lg"
            @click="loginStore.setLoginType(LoginType.Password)"
        >
            {{ $t('components.login.standard') }}
        </SButton>
    </SStack>
</template>
